export const ADMIN_ROLES = ['super_admin', 'blog_admin'];
const isBlogKey = (key) => key === 'blog' || key.startsWith('blog.');
/** Whether `role` may open the sidebar section `key`. */
export const canOpenSection = (role, key) => role === 'super_admin' || isBlogKey(key);
/** The sidebar as `role` should see it. A parent stays only if it is allowed. */
export const sectionsForRole = (sections, role) => sections
    .filter((s) => canOpenSection(role, s.key))
    .map((s) => s.children ? Object.assign(Object.assign({}, s), { children: s.children.filter((c) => canOpenSection(role, c.key)) }) : s);
/** Where `role` lands when the URL names nothing it may open. */
export const defaultSectionFor = (role) => role === 'super_admin' ? 'dashboard' : 'blog.posts';
